import { ArrowRight, Clock3 } from "lucide-react";
import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";
import { Eyebrow, Reveal } from "@/components/Motion";

export const ArticleCard = ({ article, index = 0 }) => (
  <Reveal className="article-card" delay={index * .08}>
    <Link to={`/insights/${article.slug}`} data-testid={`article-card-${article.slug}-link`}>
      <div className="article-image-wrap">
        <img src={mediaUrl(article.cover_image)} alt={article.cover_alt} loading="lazy" decoding="async" />
        <span className="article-index" aria-hidden="true">0{index + 1}</span>
      </div>
      <div className="article-card-body">
        <div className="article-meta" data-testid={`article-card-${article.slug}-metadata`}><span>{article.category}</span><span><Clock3 size={13} /> {Math.max(3, Math.ceil(article.body?.split(/\s+/).length / 220))} min read</span></div>
        <h3 data-testid={`article-card-${article.slug}-title`}>{article.title}</h3>
        <p data-testid={`article-card-${article.slug}-excerpt`}>{article.excerpt}</p>
        <div className="article-byline"><span>{article.author_name}</span><span>{new Date(article.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span></div>
      </div>
    </Link>
  </Reveal>
);

export const PageHero = ({ eyebrow, title, description, image, imageAlt = "Contemporary architecture reflecting clarity and long-term perspective" }) => (
  <section className="page-hero">
    <div className="page-hero-grid shell">
      <div><Eyebrow light>{eyebrow}</Eyebrow><h1 data-testid="page-heading">{title}</h1><p data-testid="page-description">{description}</p></div>
      <div className="page-hero-image"><img src={image} alt={imageAlt} decoding="async" /><span aria-hidden="true" /></div>
    </div>
  </section>
);

export const ConsultationBand = ({ title = "Let's Start a Conversation", copy = "Tell us about your financial objectives and the kind of guidance you are looking for.", buttonLabel = "Request a Private Consultation" }) => (
  <section className="consultation-band" data-testid="consultation-callout">
    <div className="shell consultation-inner"><div><Eyebrow light>Private consultation</Eyebrow><h2>{title}</h2><p>{copy}</p></div><Link to="/contact" className="button button--light" data-testid="consultation-band-link">{buttonLabel} <ArrowRight size={18} /></Link></div>
  </section>
);

export const EmptyState = ({ children }) => <div className="empty-state" data-testid="empty-state"><span>○</span><p>{children}</p></div>;